import React from 'react'
import RegisterAdmin from '../../Components/Admin/Register/Register-first'

function Register() {
    return (
        <div>
            <RegisterAdmin />
        </div>
    )
}

export default Register
